const Data=[
    {
        id:"1",
        title:"UNITED STATES MILITARY",
        description:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
        img:"/images/flight.jpg"
    },
    {
        id:"2",
        title:"SHIP BUILDING",
        description:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
        img:"/images/ship.jpg"

    },
    {
        id:"3",
        title:"CONSTRUCTION",
        description:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
        img:"/images/construction.jpg"

    },
    {
        id:"4",
        title:"ELECTRONICS",
        description:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
        img:"/images/electronic.jpg"

    },
    {
        id:"5",
        title:"CITY PARKS AND SERVICES",
        description:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters",
        img:"/images/citypark.jpg"
    }
]
export default Data;